export default __webpack_public_path__ + "static/img_interviewee_mkim-b3daf7b181ec2afb633dcb7e3869d3a9.png";